import React from "react";
import { useToast } from "./useToast";

export const useToastStateSync = ({
  success,
  error,
}: {
  success?: string | null;
  error?: string | null;
}) => {
  const toast = useToast();
  const previousSuccessRef = React.useRef<string | null | undefined>(undefined);
  const previousErrorRef = React.useRef<string | null | undefined>(undefined);

  React.useEffect(() => {
    if (success && success !== previousSuccessRef.current) {
      toast.success(success);
    }
    previousSuccessRef.current = success;
  }, [success, toast]);

  React.useEffect(() => {
    if (error && error !== previousErrorRef.current) {
      toast.error(error);
    }
    previousErrorRef.current = error;
  }, [error, toast]);
};
